import React, { useContext } from 'react'
import { FeatureStatesProviderContext } from '../providers/FeatureStatesProvider'
import { ActionModeType, FeatureConfigType, GeoFeatureDataType, SelectedFeatureType, ViewType } from '../utils/types'
import { useNavigate, useParams } from 'react-router-dom'
import { navigateTo } from '../../../utils/commonFunctions'
import { downloadAsShapefile } from '../utils/utilities'

const useGeoFeatures = () => {
    const navigate = useNavigate();
    const { mission_name, mission_id, tab_name } = useParams()
    const context = useContext(FeatureStatesProviderContext)
    if (!context) {
        throw new Error('useGeoFeatures must be used within a FeatureStatesProvider')
    }
    const {
        rename,
        setRename,
        sidebarOpen,
        deleteFeature,
        renameFeature,
        getGeoFeatures,
        setSidebarOpen,
        selectedFeature,
        setSelectedFeature,
        geoFeaturesDetails,
        setGeoFeaturesDetails,
    } = context

    const toggleViewMode = (view?: ViewType) => {
        const updated_tab = view ? (view === 'MAP' ? 'Feature_map' : 'Feature_list') : tab_name === 'Feature_map' ? 'Feature_list' : 'Feature_map'
        navigateTo(
            `${mission_name}/_details/${mission_id}/${updated_tab}`,
            navigate
        );
    }
    const actionFeature = (mode: ActionModeType, feature?: GeoFeatureDataType) => {
        if (mode === 'Update' && !feature) return
        toggleViewMode(['Create', 'Update'].includes(mode) ? 'MAP' : 'LIST')
        if (mode === 'Update') {
            const type = feature?.type === 'Geofence' ? 'Polygon' : 'Point'
            const formData = {
                loading: false,
                data: {
                    name: feature?.name || '',
                    description: feature?.description || '',
                    type: type,
                    polygon: feature?.polygon || [],
                    coordinates: feature?.coordinates || {
                        lat: 0,
                        long: 0,
                        altitude: 0,
                        minElevationAngle: 0
                    }
                },
                mode: mode,
                activeTool: type,
            }
            formData['uniqueId'] = feature?.areaOfInterestId
            formData['areaOfInterestManagerId'] = feature?.areaOfInterestManagerId
            formData['openModal'] = 'details'
            formData['previousData'] = feature
            formData['resetConfig'] = () => {
                setSelectedFeature(null)
                setSidebarOpen(true)
            }
            setSelectedFeature(formData as SelectedFeatureType)
        } else {
            setSidebarOpen(false)
            const formData: SelectedFeatureType = {
                loading: false,
                data: {
                    name: '',
                    description: '',
                    type: null,
                } as FeatureConfigType,
                mode: mode,
                activeTool: null,
                openModal: false
            }
            setSelectedFeature(formData)
        }
    }

    const onMenuClick = (action: string, feature?: GeoFeatureDataType) => {
        switch (action) {
            case 'Edit':
                actionFeature('Update', feature)
                break;
            case 'Delete':
                setSelectedFeature({
                    loading: false,
                    data: feature as GeoFeatureDataType,
                    mode: 'Delete',
                    activeTool: null,
                    openModal: 'delete',
                    uniqueId: feature?.areaOfInterestId
                })
                break;
            case 'Export':
                downloadAsShapefile([feature!])
                break;
            default:
                break;
        }
    }

    return {
        rename,
        setRename,
        sidebarOpen,
        onMenuClick,
        deleteFeature,
        actionFeature,
        renameFeature,
        getGeoFeatures,
        setSidebarOpen,
        toggleViewMode,
        selectedFeature,
        setSelectedFeature,
        geoFeaturesDetails,
        setGeoFeaturesDetails,
    }
}

export default useGeoFeatures